import { addLoomToSwitcherRecommendations } from '../add-loom-to-switcher-recommendations';
import { captureNotInterestedDismissal, createFireExposureEvent, getExperimentCohort, loomSwitcherExperimentWasDismissed } from '../utils';
export const createLoomExperiment = fireViewedUIEvent => {
  const cohort = getExperimentCohort();
  const isEnabled = !loomSwitcherExperimentWasDismissed() && cohort === 'variation';
  return {
    isEnabled,
    addLoomToSwitcherRecommendations,
    fireExposureEvent: createFireExposureEvent(cohort, fireViewedUIEvent),
    captureNotInterestedDismissal
  };
};